import request from '@/utils/request'
import jsonRequest from '@/utils/jsonRequest'
var qs = require('qs');

export function systemUserList(data) {
  return request({
    url: '/merchant/system/user/getMerchantSystemUserList',
    method: 'post',
    data:qs.stringify(data)
  })
}
export function delUser(data) {
  return request({
    url: '/merchant/system/user/delUser',
    method: 'post',
    data:qs.stringify(data)
  })
}
export function getMenuPermissions(data) {
  return request({
    url: '/merchant/system/user/getMenuPermissions',
    method: 'post',
    data:qs.stringify(data)
  })
}
export function setMenuPermissions(data) {
  return request({
    url: '/merchant/system/user/setMenuPermissions',
    method: 'post',
    data:qs.stringify(data)
  })
}
export function menuList() {
  return jsonRequest({
    url: '/merchant/system/user/getMerchantSystemMenu',
    method: 'post',
  })
}
export function userDetail(data) {
  return jsonRequest({
    url: '/merchant/system/user/getUserDetail',
    method: 'post',
    data
  })
}
export function addOrUpdateUser(data) {
  return jsonRequest({
    url: '/merchant/system/user/addOrUpdateUser',
    method: 'post',
    data
  })
}
export function saveCustomerPhone(data) {
  return request({
    url: '/merchant/system/user/saveCustomerPhone',
    method: 'post',
    data:qs.stringify(data)
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js